import { BaseComponent } from 'src/app/shared/components/base.component';
import { Directive, ElementRef, Input, OnInit, OnDestroy, HostListener, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ScrollDispatcher, CdkScrollable } from '@angular/cdk/scrolling';
import { AuthenticationService } from 'src/core/http/authentication.service';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[infiniteScroll]'
})


// export class InfiniteScrollDirective implements OnInit, OnDestroy, AfterViewInit {
//     private scrollEnding = new BehaviorSubject<boolean>(false);
//     public scrollEnding$ = this.scrollEnding.asObservable();
//     private elRef: ElementRef;

//     constructor(elr: ElementRef, private scrollDispatcher: ScrollDispatcher) {
//       this.elRef = elr;
//       elr.nativeElement.style.backgroundColor = 'antiquewhite';
//       this.scrollDispatcher.scrolled().subscribe((e: any) => {
//         //   console.log('I am scrolling');
//         //   console.log(e);
//           const elem = e.elementRef.nativeElement;
//           if ((elem.scrollTop + elem.clientHeight + 50) >= elem.scrollHeight ) {
//             // this.callback.call(this);
//             console.log('Scrolling end');
//           }
//         });
//     }


//     ngOnInit(): void {
//     }

//     ngAfterViewInit(): void {
//         setInterval(() => this.scrollEnding.next(true), 3000);
//     }

//     ngOnDestroy(): void {
//         this.scrollEnding.complete();
//     }

//     @HostListener('window:scroll', []) onWindowScroll() {
//         console.log('Scrolling!');
//     }
// }

export class InfiniteScrollDirective extends BaseComponent implements OnInit {
  // Expects a paramter of type of function taking one input parameter (evt) and returning void.
  // @Input('infiniteScroll') callback: (evt) => void;
  // @Input() callback: (evt) => void;
  @Input() pixelsFromBottom: number = 50;

  @Output() public scrollEnding: EventEmitter<any> = new EventEmitter<any>();


  private scrollingEvt = new Subject();
  private elRef: ElementRef;

  constructor(
    elr: ElementRef,
    private scrollDispatcher: ScrollDispatcher,
    protected authenticationService: AuthenticationService) {
    super(authenticationService);
    this.elRef = elr;
    // elr.nativeElement.style.backgroundColor = 'antiquewhite';

    this.scrollDispatcher.scrolled()
    .pipe(
        takeUntil(this.unsubscribe),
        debounceTime(300)
      )
    .subscribe((e: CdkScrollable) => {
      // INITIAL CODE
      // console.log('I am scrolling');
      // console.log(e);
      if (e && e.getElementRef() && e.getElementRef().nativeElement) {
        const elem = e.getElementRef().nativeElement;
        const isScrollContaintsTargetElemYN = elem.contains(this.elRef.nativeElement);  // used to prevent event scrolling to be targeted on left menu for example (that is outside of the main container).
        if (isScrollContaintsTargetElemYN && (elem.scrollTop + elem.clientHeight + this.pixelsFromBottom) >= elem.scrollHeight ) {
          // this.callback.call(this);
          this.scrollEnding.emit(); // { that: this.completedParam, customValue: 64}
          // console.log('Scrolling end');
        }
      } else {
        // here e is undefined because I guess (just an idea) on Mobile it is the body that is scrolling
        if ((window.scrollY + window.innerHeight + this.pixelsFromBottom) >= document.querySelector('.app-sidenav-container').clientHeight ) { // .app-container
          this.scrollEnding.emit();
          // console.log('Mobile Scrolling end');
        }
      }

      // if (e === undefined) {
      //   try {
      //     const cdkScrollableContainers = Array.from(this.scrollDispatcher.scrollContainers.keys());
      //     const matSideNavContent = cdkScrollableContainers.filter(item => item.getElementRef().nativeElement.nodeName === 'MAT-SIDENAV-CONTENT');
      //     if (matSideNavContent && matSideNavContent.length > 0) {
      //       e = matSideNavContent[0];
      //     }
      //   } catch (error) { }
      // }


      // console.log(e);

      // if (e === undefined) {
      //   // Dirty, bad, I am not pround: when e is undefined, it means the event fired on either window, html or body, which is what we are looking for.

      //   if ((window.scrollY + window.innerHeight + this.pixelsFromBottom) >= document.querySelector('.app-container').clientHeight ) {
      //     this.scrollEnding.emit();
      //     // console.log('Scrolling end');
      //   }
      // }


    });
  }


  ngOnInit(): void {
    // this.scrollingEvt.pipe(
    //   debounceTime(300)
    // ).subscribe((e: any) => {
    //   const elem = e.target;
    //   if ((elem.scrollTop + elem.clientHeight + 50) >= elem.scrollHeight ) {
    //     this.callback.call(this);
    //   }
    //   // console.log('scrollHeight: ' + elem.scrollHeight);
    //   // console.log('scrollTop: ' + elem.scrollTop);
    //   // console.log('clientHeight: ' + elem.clientHeight);
    // });
  }

  // @HostListener('scroll', ['$event']) onScroll(event: any) {
  //   this.scrollingEvt.next(event);
  // }

}

